import { useEffect, useState } from 'react';
import { facturasService } from '../services/api';
import '../styles/Clientes.css';

const Facturas = () => {
  const [facturas, setFacturas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filtros, setFiltros] = useState({
    estado: '',
    suplidor_id: ''
  });

  useEffect(() => {
    cargarFacturas();
  }, [filtros]);

  const cargarFacturas = async () => {
    try {
      setLoading(true);
      const response = await facturasService.getFacturas(filtros);
      setFacturas(response.data.facturas || []);
    } catch (error) {
      console.error('Error al cargar facturas:', error);
      setError('Error al cargar facturas');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('es-DO');
  };

  const getEstadoBadge = (estado) => {
    const colores = {
      pendiente: '#f39c12',
      aprobada: '#27ae60',
      rechazada: '#e74c3c',
      pagada: '#3498db'
    };
    return (
      <span style={{
        backgroundColor: colores[estado] || '#95a5a6',
        color: '#fff',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '0.85rem'
      }}>
        {estado?.toUpperCase()}
      </span>
    );
  };

  if (loading) return <div className="loading">Cargando facturas...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>🧾 Facturas de Suplidores</h1>
        <button className="btn btn-primary">+ Nueva Factura</button>
      </div>

      {error && <div className="banner error">{error}</div>}

      {/* Filtros */}
      <div className="card" style={{marginBottom: '1rem'}}>
        <div style={{padding: '1rem', display: 'flex', gap: '1rem', alignItems: 'center'}}>
          <div>
            <label style={{marginRight: '0.5rem'}}>Estado:</label>
            <select
              value={filtros.estado}
              onChange={(e) => setFiltros({...filtros, estado: e.target.value})}
              style={{padding: '0.5rem'}}
            >
              <option value="">Todos</option>
              <option value="pendiente">Pendiente</option>
              <option value="aprobada">Aprobada</option>
              <option value="rechazada">Rechazada</option>
              <option value="pagada">Pagada</option>
            </select>
          </div>
        </div>
      </div>

      {/* Tabla de Facturas */}
      <div className="card">
        <div className="card-title">
          Lista de Facturas ({facturas.length})
        </div>

        {facturas.length === 0 ? (
          <p style={{padding: '2rem', textAlign: 'center', color: '#666'}}>
            No hay facturas registradas
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Número</th>
                  <th>Suplidor</th>
                  <th>Fecha</th>
                  <th>Monto</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {facturas.map((factura) => (
                  <tr key={factura.id}>
                    <td>{factura.id}</td>
                    <td>{factura.numero_factura}</td>
                    <td>{factura.suplidor?.nombre || '-'}</td>
                    <td>{formatDate(factura.fecha_factura)}</td>
                    <td style={{fontWeight: 'bold'}}>{formatMoney(factura.monto_total)}</td>
                    <td>{getEstadoBadge(factura.estado)}</td>
                    <td>
                      <button className="btn-icon" title="Ver detalles">👁️</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Facturas;
